import React, {useRef, useEffect} from "react";
import useCamera from "./hook";
import LoaderLulo from "../../../../components/loaderLulo";
import Loader from "../../../../components/loader";
import placeholder from '../../../../assets/image/lulo/_Placeholder.png'
import borderFront from '../../../../assets/image/lulo/border-front.png'

export default function CardCaptureV6WhateMarks() {
    const lottieRef = useRef();
    const {
        videoRef,
        canvasRef,
        canvasCroppedImageRef,
        indicatorRotate,
        debug,
        step,
        stepHistory,
        ocr,
        isCard,
        isImageValidate,
        loading,
        projectName,
        typeCapture,
        goBack,
        isMovil,
        takeManualPhoto
    } = useCamera()

    useEffect(() => {
        const animation = lottieRef.current;
        if (animation) {
            animation.setSpeed(2.5);
            animation.play();
        }
    }, [])
    // 300 y 500

    if (isMovil()) {
        return (
            <div style={{margin: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: projectName.toLowerCase().includes('lulo') ? '#1F2639' : '#000'}}>
                {loading && (
                    <div style={{position: 'absolute', top: '50%', left: '50%', zIndex: '100', transform: 'translate(-50%, -50%)'}}>
                        {projectName.toLowerCase().includes('lulo') ? (
                            <LoaderLulo />
                        ) : (
                            <Loader />
                        )}
                    </div>
                )}
                <div onClick={goBack} style={{position: 'absolute', display: 'none', fontSize: 30, fontWeight: 700, textAlign: 'center', zIndex: 20, top: 30, right: 40, width: 25, height: 25, color: 'white', transform: 'rotate(90deg)'}} id="img-back-ado">

                </div>

                <div id="guide-user-ado" style={{ border: '5px solid #ACFFB7', transform: 'scale(0)', position: 'relative', borderRadius: 16, width: '70vw', height: '56vh', overflow: 'hidden', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'center' }}>
                    <img style={{position: 'absolute', height: '53vh', width: '65vw'}} src={typeCapture === '1' ?  borderFront : placeholder} alt="aaa"/>
                    <video style={{ flex: '2', display: 'block' }} id="video-camera" className={`container__camera-movil video-movil`} ref={videoRef} controls={false} autoPlay playsInline />
                    {typeCapture === '1' ? (
                        <div style={{ position: 'absolute', top: '0', left: 8, width: '80%', height: '-webkit-fill-available', display: 'flex', flexDirection: 'column', alignItems: 'end', justifyContent: 'flex-end', writingMode: 'vertical-rl', padding: '10px', }}>
                            <div id="preview-user-mark" style={{
                                transform: 'rotate(90deg)',
                                marginLeft: 30,
                                alignItems: 'end',
                                display: 'none',
                            }}>
                                <img
                                    id="user-mark"
                                    alt="user-mark"
                                    src="https://ado-card-capture-data-qa.s3.amazonaws.com/soadtech/user-mark.png"
                                    style={{width: 92}}
                                />
                            </div>
                            <div id="preview-text-mark" style={{
                                color: 'white',
                                backgroundColor: '#363636',
                                borderRadius: 8,
                                padding: 6,
                                textAlign: 'center',
                                fontWeight: '700',
                                height: '90%',
                                margin: 'auto 0'
                            }}>
                                Ubíca la parte de adelante de tu documento
                            </div>
                        </div>
                    ) : (
                        <div style={{
                            position: 'absolute',
                            top: '0',
                            right: 0,
                            width: '53vh',
                            height: '-webkit-fill-available',
                            display: 'flex',
                            flexDirection: 'column-reverse',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            writingMode: 'vertical-rl',
                            padding: '10px',
                        }}>
                            <div id="preview-bar-mark" style={{
                                // transform: 'rotate(90deg)',
                                // marginLeft: 30,
                                // marginRight: '10%',
                                position: 'absolute',
                                left: 10,
                                height: '90%',
                                justifyContent: 'center',
                                display: 'flex',
                            }}>
                                <img
                                    alt="bar-mark"
                                    src="https://ado-card-capture-data-qa.s3.amazonaws.com/soadtech/bar-code-2.png"
                                    style={{width: 60, height: '100%'}}
                                />
                            </div>
                            <div id="preview-text-mark-back" style={{
                                color: 'white',
                                backgroundColor: '#363636',
                                borderRadius: 8,
                                padding: 6,
                                textAlign: 'center',
                                fontWeight: '700',
                                height: '90%',
                                margin: 'auto 0'
                            }}>
                                Ubica la parte de adelante de tu documento
                            </div>
                        </div>
                    )}


                </div>
                <div onClick={takeManualPhoto} id="take-photo-ado" style={{
                    position: 'absolute',
                    top: '92%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    border: '3px solid #ffffff',
                    borderRadius: '50%',
                    display: 'none',
                    width: '3rem',
                    height: '3rem',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        width: '90%',
                        height: '90%',
                        backgroundColor: 'white',
                        borderRadius: '50%'
                    }} />
                </div>
                <canvas
                    id="canvas-view"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'none',
                    }}
                    ref={canvasRef}
                />
                <img alt="imgResult" id="imgResult" style={{display: 'none', width: '100%'}} />
                <div id="message-alert-ado" className="message-alert-ado">
                    <h2>Error al validar el documento</h2>
                    <p>Verifique que el documento se vea correctamente</p>
                </div>
            </div>
        )
    }

    return (
        <div style={{backgroundColor: '#000'}} className="container__camera">
            {debug === 'true' && (
                <>
                    <div style={{position: 'absolute', zIndex: 200, width: '100%', top: 0, display: 'flex', justifyContent: 'space-around'}}>
                        <div>
                            <h5 style={{color: 'white'}}>Image</h5>
                            <h5 style={{color: 'white'}}>{isImageValidate ? 'Si' : 'No'}</h5>
                        </div>
                        <div>
                            <h5 style={{color: 'white'}}>OCR</h5>
                            <h5 style={{color: 'white'}}>{ocr}</h5>
                        </div>
                        <div>
                            <h5 style={{color: 'white'}}>isCard</h5>
                            <h5 style={{color: 'white'}}>{isCard}</h5>
                        </div>
                    </div>
                </>
            )}


            <div id="container-ado-camera" style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }}>
                <video id="video-camera" className={`container__camera-camera ${!isMovil() ? 'video-mirror' : ''}`} ref={videoRef} autoPlay playsInline/>
            </div>

            <div onClick={goBack} className="imgback" id="img-back-ado">
                X
            </div>

            <input id="input-ado-copy" style={{display: 'none',  width: '90%', padding: 20}} />
            <canvas id="canvas-view" ref={canvasRef} style={{display: 'none'}}  />

            <img alt="imgResult" id="imgResult" style={{display: 'none', width: '100%'}} />
            {debug === 'true' && (
                <>
                    <div style={{position: 'absolute', width: '100%', bottom: '8rem', display: 'flex', justifyContent: 'space-around'}}>
                        <div>
                            <div style={{height: 200, overflowY: 'scroll', display: 'none'}}>
                                <h5 style={{color: 'white'}}>Step history</h5>
                                {stepHistory.map(step => (
                                    <h5 style={{color: 'white'}}>{step}</h5>
                                ))}
                            </div>

                            <div style={{marginTop: 10}}>
                                <h5 style={{color: 'white'}}>Current Step</h5>
                                <h5 style={{color: 'white'}}>{step}</h5>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
